import React, { Component } from "react";
import { connect } from "react-redux";
import { monthOptions, yearOptions } from "../config";
import FlexView from "react-flexview";
import * as R from "ramda";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SalesReportBy from "./salesReportBy";
import SalesReportYearToDate from "./salesReportYearToDateBy";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";

class KacabReportByTypeByTL extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            dataTL: [],
            kodeCabang: null,
            month: null,
            year: null,
            teamLead: null,
            search: {},
            doSearch: false,
        };
    };

    componentDidMount = async () => {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(
              (item) => item.value === currentDate.getFullYear()
            ),
        }));
        await this.fetchDataCabang();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Tipe By Team Leader",
            args: null,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: filteredData,
                }))
            }
        }
        this.handleTriggerLoading();
    };

    fetchDataTL = async (kodeCabang) => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
            setError: this.props.setError,
            menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Tipe By Team Leader",
            args: { paramFilters: { kodeCabang: kodeCabang, userNameLead: this.props.auth.user.username } },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTL: res.data.data,
            }));
        }
        this.handleTriggerLoading();
    };

    handleSearchValueChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
        if (R.equals(name, "kodeCabang")) {
            this.setState((prevValue) => ({
                ...prevValue,
                teamLead: null,
            }));
            if(!value) return
            await this.fetchDataTL(value.value);
        }
    };

    handleSearch = () => {
        const { kodeCabang, teamLead, month, year } = this.state;

        this.setState((prevValue) => ({
            ...prevValue,
            search: removeNullFields({
                kodeCabangList: [kodeCabang?.value],
                month: month?.value,
                year: year?.value,
                teamLeaderEmployeeId: teamLead?.value,
                salesId: null
            }),
            doSearch: true,
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{ gap: "20px", alignItems: "center" }}>
                        <SimpleDDL
                            isClearable
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleDDL
                            isClearable
                            id="select_options_month"
                            box="search"
                            name="month"
                            containerclassname="width width-250px"
                            placeholder="Bulan"
                            menuPosition="fixed"
                            options={monthOptions}
                            value={this.state.month}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleDDL
                            isClearable
                            id="select_options_year"
                            box="search"
                            name="year"
                            containerclassname="width width-250px"
                            placeholder="Tahun"
                            menuPosition="fixed"
                            options={yearOptions}
                            value={this.state.year}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleDDL
                            isClearable
                            id="select_options_team_lead"
                            box="search"
                            name="teamLead"
                            containerclassname="width width-250px"
                            placeholder="Select TL"
                            menuPosition="fixed"
                            options={this.state.dataTL.map(item => mapToObjectDDL(item.salesLeadName, item.employeeId))}
                            value={this.state.teamLead}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleButton
                            styles={{ marginBottom: "15px" }}
                            onClick={this.handleSearch}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Jualan Per Varian</Tab>
                            <Tab>Laporan Jualan Variant Year To Date</Tab>
                            <Tab>Laporan Jualan Per Tipe</Tab>
                            <Tab>Laporan Jualan Per Tipe Year To Date</Tab>
                            <Tab>Laporan Jualan Per Series</Tab>
                            <Tab>Laporan Jualan Per Series Year To Date</Tab>
                            <Tab>Laporan Jualan Per Sub Segmen</Tab>
                            <Tab>Laporan Jualan Per Sub Segmen Year To Date</Tab>
                        </TabList>
                        <TabPanel>
                            <SalesReportBy
                                {...this.props}
                                tab="type"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportYearToDate
                                {...this.props}
                                tab="variant"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportBy
                                {...this.props}
                                tab="type"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportYearToDate
                                {...this.props}
                                tab="type"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportBy
                                {...this.props}
                                tab="series"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportYearToDate
                                {...this.props}
                                tab="series"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportBy
                                {...this.props}
                                tab="subSegment"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SalesReportYearToDate
                                {...this.props}
                                tab="subSegment"
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
            </>
        );
    };
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(KacabReportByTypeByTL);